const {
  arrowUp, arrowLeft, arrowRight, arrowDown
} = require('../components/icons.js')
const requestMic = require('./utility/requestMic.js')

module.exports = function store(state, emitter) {
  state.activeButtons = []

  state.isSoundLibraryOpen = false
  state.isRecordingOpen = false
  state.imready = false
  state.typing = false
  state.selectedCategory = null

  state.boardLayout = [
    { key: 'w', value: 'W', className: 'fade' },
    { key: 'arrowup', value: arrowUp, className: '' },
    { key: 'a', value: 'A', className: 'fade' },
    { key: 'arrowleft', value: arrowLeft, className: '' },
    { key: ' ', value: 'SPACE', className: 'space' },
    { key: 'arrowright', value: arrowRight, className: '' },
    { key: 's', value: 'S', className: 'fade' },
    { key: 'arrowdown', value: arrowDown, className: '' },
    { key: 'd', value: 'D', className: 'fade' },
  ]

  window.addEventListener('resize', () => emitter.emit('render'))

  emitter.on('unfocus', () => {
    if (document.activeElement) {
      document.activeElement.blur()
    }
  })

  emitter.on('toggleshuffle', () => {
    state.shuffle = !state.shuffle
    emitter.emit('render')
  })
  emitter.on('triggerbutton', () => {
    emitter.emit('releasebutton')
    console.log('triggerbutton')
    let keyIndex

      keyIndex = state.nextSampleIndex
      state.nextSampleIndex++
      console.log('nextSampleIndex', state.nextSampleIndex)
      if (state.nextSampleIndex >= state.sampleBoard.length) {
        console.log('resetting')
        state.nextSampleIndex = 0
      }
      if (state.shuffle){
        state.nextSampleIndex = Math.floor(Math.random() * state.sampleBoard.length)
      }
    
    const index = state.activeButtons.indexOf(keyIndex)
    if (index === -1) {
      state.activeButtons.push(keyIndex)
    }
    state.lastActiveIndex = keyIndex
    emitter.emit('render')
  })

  emitter.on('releasebutton', () => {
    let keyIndex = state.lastActiveIndex
    const index = state.activeButtons.indexOf(keyIndex)
    if (index !== -1) {
      state.activeButtons.splice(index, 1)
    }
    emitter.emit('render')
  })

  emitter.on('togglesoundlibrary', () => {
    state.isRecordingOpen = false
    state.isSoundLibraryOpen = !state.isSoundLibraryOpen
    emitter.emit('deselectsample')
    emitter.emit('unfocus')
    emitter.emit('render')
  })

  emitter.on('togglerecording', () => {
    requestMic()
      .then(() => {
        console.log('yo')
        state.isRecordingOpen = !state.isRecordingOpen
        state.isSoundLibraryOpen = false
        emitter.emit('deselectsample')
        emitter.emit('unfocus')
        emitter.emit('render')
      })
      .catch((e) => {
        console.log('error', e)
      })
  })

  emitter.on('starttyping', () => {
    state.typing = true
  })

  emitter.on('stoptyping', () => {
    state.typing = false
  })

  emitter.on('flashbuttons', () => {
    function indexToXY(index, width) {
      width = width || 3
      return {
        x: index % width,
        y: parseInt(index / width)
      }
    }
    let buttons = document.querySelectorAll('#grid button')
    buttons = Array.prototype.slice.call( buttons )
    buttons.forEach((button, i) => {
      const { x, y } = indexToXY(i)
      setTimeout(() => {
        button.classList.add('active')
        button.classList.add('flash')
      }, (x+y)*50 + 50)
      setTimeout(() => {
        button.classList.remove('active')
        button.classList.remove('flash')
      }, ((x+y)*50)+250)
    })
  })

  emitter.on('removesample', (sampleId) => {
    state.sampleBoard = state.sampleBoard.filter(s => s !== sampleId)
    emitter.emit('render')
  })

  
  emitter.on('flashbutton', (index) => {
    let buttons = document.querySelectorAll('#grid button')
    buttons = Array.prototype.slice.call( buttons )
    let button = buttons[index]
    setTimeout(() => {
      button.classList.add('active')
      button.classList.add('flash')
    }, 50)
    setTimeout(() => {
      button.classList.remove('active')
      button.classList.remove('flash')
    }, 250)
  })
}
